import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { Rol } from './roles.model';
import { Integrante } from '../integrante/integrante.model';
import { Persona } from '@rpe/registro-personas-empresas-lib';


// LOAD
export const entityRolLoadRequest = createAction('[ENTITYROL] Load Request');

export const entityRolLoadFailure = createAction(
  '[ENTITYROL] Load Failure',
  props<{ error: Error }>()
);

export const entityRolLoadSuccess = createAction(
  '[ENTITYROL] Load Success',
  props<{ items: Rol[] }>()
);

// ADD
export const entityRolAddRequest = createAction(
  '[ENTITYROL] Add Request',
  props<{ item: Rol }>()
);

export const entityRolAddFailure = createAction(
  '[ENTITYROL] Add Failure',
  props<{ error: Error }>()
);

export const entityRolAddSuccess = createAction(
  '[ENTITYROL] Add Success',
  props<{ item: Rol }>()
);

// CHANGE
export const entityRolChangeRequest = createAction(
  '[ENTITYROL] Change Request',
  props<{ item: Rol, persona?: Persona }>()
);

export const entityRolChangeFailure = createAction(
  '[ENTITYROL] Change Failure',
  props<{ error: Error }>()
);

export const entityRolChangeSuccess = createAction(
  '[ENTITYROL] Change Success',
  props<{ item: Rol }>()
);

// DELETE
export const entityRolDeleteRequest = createAction(
  '[ENTITYROL] Delete Request',
  props<{ item: Integrante }>()
);

export const entityRolDeleteFailure = createAction(
  '[ENTITYROL] Delete Failure',
  props<{ error: Error }>()
);

export const entityRolDeleteSuccess = createAction(
  '[ENTITYROL] Delete Success',
  props<{ item: Rol }>()
);
